module.exports = __webpack_public_path__ + "img/vertical_4_6_5010.e0162517.png";